import styled from 'styled-components';

export const FilterIconWrapper = styled.div`
  display: flex;
  align-items: center;

  .all-selection {
    margin-top:${({ theme: { token } }) => token.margin}px;
`;


